import React, { Context } from 'react';

import { INotificationDisplay } from 'src/elements/Notifications';
import { INotificationManager } from './types';

type TChangeOrDisplayNotification = INotificationManager | INotificationDisplay;

const withNotificationContext =
  (
    Component: React.ComponentType<TChangeOrDisplayNotification>,
    ContextComponent: Context<INotificationManager>
  ) =>
  (props: TChangeOrDisplayNotification) => (
    <ContextComponent.Consumer>
      {(state) => <Component {...({ ...props, ...state } as TChangeOrDisplayNotification)} />}
    </ContextComponent.Consumer>
  );

export default withNotificationContext;
